import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=a3e41168"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"
import style0 from "./Translation.vue?vue&type=style&index=0&id=a3e41168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports